import { useSelector } from 'react-redux'
import { fetchProductDetail } from '../../products/utils/fetchProductDetail'
import { StocksSlice, selectStockIds } from '../../products/storage/stocks.slice'
import { ProductDetailsApiResponse } from '../../products/storage'
import { useAppDispatch } from '../../../store/rootStore'

export const useCheckLocalStorage = () => {
  const ids = useSelector(selectStockIds)
  const dispatch = useAppDispatch()

  const checkSeedInLocalStorage = async (
    productIds: number[],
    accountNumber: string,
    branchId: string | undefined,
  ) => {
    const tasks: Promise<ProductDetailsApiResponse>[] = []
    productIds.forEach((id) => {
      if (!ids.includes(id.toString())) {
        tasks.push(fetchProductDetail(id.toString(), accountNumber, branchId))
      }
    })
    const results = await Promise.all(tasks)
    dispatch(StocksSlice.actions.addStockArray(results))
  }

  return { checkSeedInLocalStorage }
}
